import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connectMenu } from 'react-instantsearch-dom';
import cn from 'classnames';
import * as styles from './styles';
import { DEFAULT_TYPE_LABEL } from '../../../common';

const Menu = ({ items, refine, createURL, label, defaultLabel }) => {
  items = items.sort((a, b) => {
    if (a.label > b.label) {
      return 1;
    }
    if (a.label < b.label) {
      return -1;
    }
    return 0;
  });

  return (
    <ul className={styles.typeMenu}>
      <li
        className={cn(styles.typeMenuItem, {
          [styles.isActive]: label == defaultLabel,
        })}
      >
        <a
          href={createURL('')}
          className={styles.typeMenuLink}
          onClick={(event) => {
            event.preventDefault();
            refine('');
          }}
        >
          {defaultLabel}
        </a>
      </li>
      {items.map((item) => (
        <li
          key={item.value}
          className={cn(styles.typeMenuItem, {
            [styles.isActive]: item.isRefined,
          })}
        >
          <a
            href={createURL(item.value)}
            className={styles.typeMenuLink}
            onClick={(event) => {
              event.preventDefault();
              refine(item.value);
            }}
          >
            {item.label}
          </a>
        </li>
      ))}
    </ul>
  );
};

const CustomMenu = connectMenu(Menu);

const ProductTypeMenu = ({ isOpen, label, attribute, defaultLabel }) => {
  return (
    <div
      className={cn('animate-fade-in-up-start', {
        ['animate-fade-in-up-end']: isOpen,
      })}
    >
      <CustomMenu
        attribute={attribute}
        label={label}
        defaultLabel={defaultLabel}
        key={attribute}
        limit={100}
      />
    </div>
  );
};

ProductTypeMenu.propTypes = {
  isOpen: PropTypes.bool,
  label: PropTypes.string,
  attribute: PropTypes.string.isRequired,
  defaultLabel: PropTypes.string,
};

ProductTypeMenu.defaultProps = {
  isOpen: false,
  label: '',
  defaultLabel: '',
};

export default ProductTypeMenu;
